import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import StatusContext from '../../../contexts/StatusContext'
import StocksContext from '../../../contexts/StocksContext'
import "./stockssymbols.css"

export const DialogProgress= () => {

  const {
    changeLanguageEnglish,
    waitonResponse
} = React.useContext(StatusContext);

const {
  showProgressDialog,
} = React.useContext(StocksContext);


  return (
   
    <React.Fragment>
   
        <Dialog
          open={showProgressDialog}
         
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const email = formJson.email;
              console.log(email);
              
            },
          }}
        >

        <DialogTitle className="stocksdialogProgressTitle" style = {{fontSize:'16px', color:'maroon'}}>{changeLanguageEnglish('stocks', 'prepareresponse')}</DialogTitle>

        <DialogContent dividers>
         
              <div>
              <label className="stocksdialogProgressText"> {changeLanguageEnglish('stocks', 'prepareresponse_1')} </label>
              <br></br>
              {waitonResponse}
              </div>
          
        </DialogContent>
      </Dialog>
    </React.Fragment>
    
  );
  
}